var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.faqs),function(question){return _c('div',{key:question.id},[_c('faq',{attrs:{"question":question}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }